import Sandbox from '../../components/Sandbox/Sandbox';
import ExperimentalFeatureBanner from '../../components/ExperimentalFeatureBanner/ExperimentalFeatureBanner';
import './AlkyMation.scss';

const AlkyMation = () => (
  <div className="alkymation-page">
    <ExperimentalFeatureBanner />
    <div className="alkymation-card">
      <Sandbox />
    </div>
  </div>
);

export default AlkyMation;
